import { render, staticRenderFns } from "./critical.vue?vue&type=template&id=624378f3&scoped=true"
import script from "./critical.vue?vue&type=script&lang=js"
export * from "./critical.vue?vue&type=script&lang=js"
import style0 from "./critical.vue?vue&type=style&index=0&id=624378f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@5.2.7_prettier@2.8.7_react-dom@17.0.2_react@_xbvnx5joxenxrdtaq55cnp74na/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624378f3",
  null
  
)

export default component.exports